import { createEntityAdapter, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ID } from 'utils/id'

export type Trigger = {
  id: ID
  payload?: string
  type: 'feedback' | 'iframe' | 'reward'
}

interface Context {
  [key: string]: string|number|boolean
}

const triggerAdapter = createEntityAdapter<Trigger>({
  selectId: (trigger) => trigger.id,
})

export const triggerSlice = createSlice({
  initialState: triggerAdapter.getInitialState({
    context: {},
  } as {
    context: Context
  }),
  name: 'trigger',
  reducers: {
    addContext: (state, action: PayloadAction<{ key: string; value: string|number|boolean }>) => {
      state.context[action.payload.key] = action.payload.value

      return state
    },
    addTriggers: triggerAdapter.addMany,
    clearContext: (state) => {
      state.context = {}

      return state
    },
    removeTrigger: triggerAdapter.removeOne,
    setContext: (state, action: PayloadAction<Context>) => {
      state.context = action.payload ?? {}

      return state
    },
  },
})

export const {
  addContext,
  addTriggers,
  clearContext,
  removeTrigger,
  setContext,
} = triggerSlice.actions

